import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const SoundOnIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="soundOn" ref={ref} {...props}>
      <path d="M10.92,6.37a.76.76,0,0,0-.78.06L6.26,9.26H4.56a.74.74,0,0,0-.75.75v4a.74.74,0,0,0,.75.75h1.7l3.88,2.83a.79.79,0,0,0,.44.14.81.81,0,0,0,.34-.08.76.76,0,0,0,.41-.67V7A.76.76,0,0,0,10.92,6.37Zm-1.09,9.1L7,13.37a.74.74,0,0,0-.45-.15H5.31V10.76H6.5A.74.74,0,0,0,7,10.61l2.88-2.1ZM20.19,12a8.65,8.65,0,0,1-4.89,7.76.8.8,0,0,1-.33.08.73.73,0,0,1-.67-.43.74.74,0,0,1,.35-1,7.11,7.11,0,0,0,0-12.82.75.75,0,1,1,.65-1.35A8.65,8.65,0,0,1,20.19,12ZM17,12v0a5.39,5.39,0,0,1-2.82,4.74.73.73,0,0,1-.35.09.75.75,0,0,1-.36-1.4,3.92,3.92,0,0,0,2-3.43v0a3.92,3.92,0,0,0-2-3.43.75.75,0,0,1,.71-1.31A5.39,5.39,0,0,1,17,12Z" />
    </Icon>
  ),
) as IconWithRender;

SoundOnIcon.displayName = 'SoundOnIcon';
SoundOnIcon.renderIcon = (props) => <SoundOnIcon {...props} />;
export default SoundOnIcon;
